import * as Yup from 'yup';

export const schema = Yup.object().shape({
  // GameEntryFeeGameID: Yup.string().required('انتخاب بازی الزامی است'),
  // GameEntryFeeAmount: Yup.string().required('وارد کردن هزینه قابل پرداخت الزامی است'),
  // GameEntryFeeDurationTime: Yup.string().required('وارد کردن مدت زمان الزامی است'),
});
